import { TarefaCardProps } from "../../interfaces/tasks"
import { DragEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { listarMembrosProjeto } from "../../services/projetos"
import { MembroProjeto } from "../../interfaces/projetos"
import { useLocation } from 'react-router-dom'
import avatarDefault from "../../assets/img/avatarDefault.png"
import "./index.css"
import '../../styles/paginaListaDados.css'

const TarefaCard = ({ id, titulo, ideia, tarefa, situacao, abrirModalEditarTarefa, setTarefaSelecionada }: TarefaCardProps) => {

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto")

  const [membros, setMembros] = useState<MembroProjeto[]>([])

  const responsavel = tarefa ? membros.find(m => m.usuario.id === tarefa.idResponsavel) : null

  const novaData = tarefa && new Date(tarefa?.dataEntrega);
  const novaDataEntrega = novaData?.setDate(novaData.getDate() + 1);

  const onDragTarefa = (e: DragEvent<HTMLDivElement>, idTarefa: string) => {
    e.dataTransfer.setData("tarefa", idTarefa)
  }

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        setMembros(resposta.data);

      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (
    <div
      className="tarefa-kanban-card"
      draggable
      onDragStart={(e) => { onDragTarefa(e, id); setTarefaSelecionada && setTarefaSelecionada(tarefa) }}
      onClick={() => abrirModalEditarTarefa && abrirModalEditarTarefa(tarefa)}
    >
      <div className="tarefa-kanban-header">
        <div className="tarefa-kanban-header-left">
          <p className="tarefa-kanban-title" unselectable="off">
            {tarefa ? tarefa.titulo : titulo}
          </p>
          {responsavel && (
            <div className="tarefa-kanban-avatar" title={responsavel.usuario.nome}>
              <img
                src={responsavel.usuario.avatar || avatarDefault}
                alt={responsavel.usuario.nome}
              />
            </div>
          )}
        </div>
      </div>

      <p className="tarefa-kanban-description">{tarefa ? tarefa.ideia : ideia}</p>

      {situacao && (
        <div className="tarefa-kanban-footer">
          <button
            className={`tarefa-kanban-status ${(situacao === "concluída" || situacao === "Desenvolvido") && "tarefa-kanban-status-concluida"} ${situacao === "atrasada" && "tarefa-kanban-status-atrasada"} ${(situacao === "pendente" || situacao === "Pendente") && "tarefa-kanban-status-pendente"}`}
          >
            {situacao}
          </button>
          <span className="tarefa-kanban-date">
            {novaDataEntrega && new Date(novaDataEntrega).toLocaleDateString("pt-BR")}
          </span>
        </div>
      )}
    </div>
  );
};

export default TarefaCard;
